import styled, { keyframes } from 'styled-components';

export const LoginContainer = styled.div`
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
  background-color: #101c11;
  gap: 30px;
  padding: 40px;
  box-sizing: border-box;
  position: relative;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    padding: 20px;
    gap: 20px;
    height: auto;
    min-height: 100vh;
    overflow-x: hidden;
  }
`;

export const BackgroundImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
`;

export const GraphicSide = styled.div`
  flex: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #758b77;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  height: calc(100vh - 80px);
  box-sizing: border-box;

  @media (max-width: 768px) {
    width: 100%;
    order: -1;
    position: relative;
    max-height: 200px;
  }
`;

export const Logo = styled.img`
  width: 60px;
  height: auto;
`;

export const LogoContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
  
  &.mobile-logo {
    display: none;

    @media (max-width: 768px) {
      display: flex;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: auto; 
      margin-bottom: 0; 
      z-index: 2; 
      padding: 10px;
      border-radius: 50%; 
      justify-content: center; 
      align-items: center; 

      ${Logo} {
        width: 50px;
        height: auto;
      }
    }
  }
`;

export const FormSide = styled.div`
  flex: 0.8;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 60px 40px;
  background: #111E12;
  border-radius: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  color: #E5E5E5;
  height: calc(100vh - 80px);
  max-width: 450px;
  box-sizing: border-box;
  position: relative;

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    min-height: 70vh;
    padding: 40px 20px 20px 20px;
    order: 1;
    justify-content: flex-start;
    overflow-y: auto;

    & > ${LogoContainer}:not(.mobile-logo) {
        display: none;
    }
  }
`;

export const WelcomeContainer = styled.div`
  width: 100%;
  max-width: 400px;
  text-align: left;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    margin-top: 10px;
    margin-bottom: 15px;
    align-items: flex-start;
  }
`;

export const LoginForm = styled.form`
  margin-top: 20px;
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  color: #E5E5E5;

  @media (max-width: 768px) {
     margin-top: 10px;
     gap: 10px;
  }
`;

export const RegisterTitle = styled.h2`
  color: #E5E5E5;
  font-family: Inter, sans-serif;
  letter-spacing: -0.02em;
  margin-bottom: 8px;
  font-size: 32px;
  font-weight: bold;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 24px;
    margin-bottom: 4px;
    text-align: center;
  }
`;

export const InputGroup = styled.div`
  width: 100%;
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #ccc;
  height: 50px;
  color: #111E12;
  font-size: 16px;
  box-sizing: border-box;
`;

export const Button = styled.button`
  width: 100%;
  padding: 10px;
  background: #E5E5E5;
  color: #111E12;
  border: none;
  cursor: pointer;
  border-radius: 10px;
  font-size: 18px;
  font-weight: bold;
  height: 60px;
  transition: background 0.2s, color 0.2s;
  
  &:hover:not(:disabled) {
    background: #E9FD8C;
    color: #111E12;
  }

  &:disabled {
    background-color: #758b77;
    cursor: not-allowed;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 5px 0;
`;

export const Checkbox = styled.input`
  margin-right: 10px;
  width: 18px;
  height: 18px;
  accent-color: #E9FD8C;
`;

export const Label = styled.label`
  font-size: 14px;
  color: #758b77;
  margin: 0;
  line-height: 1.4;

  a {
    color: white;
    font-weight: 500;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const LoginLink = styled.span`
  text-align: center;
  margin-top: 16px;
  color: #758b77;
  font-size: 14px;

  a {
    color: white;
    font-weight: 500;
    text-decoration: none;
    margin-left: 4px;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const BackButton = styled.button`
  position: absolute;
  top: 20px;
  left: 20px;
  background: transparent;
  border: none;
  color: #E5E5E5;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 6px;
  transition: background 0.2s;
  z-index: 10;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  svg {
    width: 20px;
    height: 20px;
  }

   @media (max-width: 768px) {
      top: 10px;
      left: 10px;
  }
`;